var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { section: true, mobile: _vm.isMobile(_vm.$mq) } },
    [
      _c("h2", [_vm._v("Brilliant Premium is a great gift for...")]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "items" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "icon" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-satellite-orange2" })
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Students")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Master concepts through problem solving in math, science, and computer science. Build\n        intuition instead of memorizing formulas.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "icon" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-brain-orange" })
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Professionals")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Keep your knowledge base fresh and prepare for quantitative interviews. Explore topics\n        from probability to computer science to machine learning.\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "icon globe" }, [
          _c("span", { staticClass: "b-sprite-paywall-pix-globe2" })
        ]),
        _vm._v(" "),
        _c("h3", [_vm._v("Lifelong learners")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n        Choose from fun, guided exercises in hundreds of interesting topics. Keep your mind active\n        and improve critical thinking skills.\n      "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }